import { PIXI } from '@colonist/pixi';
import { RoundedBgView } from './RoundedBgView.ts';
import { SectionView } from './SectionView.ts';
import { Sprites } from '../ui_game/UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../UIGameSpriteHandler.ts';
export class SectionBgView extends SectionView {
    drawBg(color = 0x000000, alpha = 0.8, outlineThickness = 0, outlineColor = 0xFFFFFF, outlineAlpha = 1, borderRadius = 5) {
        this.removeRoundedBg();
        const newBg = new PIXI.Graphics();
        if (outlineThickness != 0) newBg.lineStyle(outlineThickness, outlineColor, outlineAlpha);
        newBg.beginFill(color, alpha);
        newBg.drawRoundedRect(0, 0, this.initialPosition.w, this.initialPosition.h, borderRadius);
        newBg.endFill();
        this.addChild(newBg);
        this.replaceOldBg(newBg);
        this.bg.zIndex = -1;
        this.sortChildren();
    }
    drawRoundedBg(texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section), useInitialPosition = false, radius) {
        if (this.sameRoundedBg(texture)) return;
        this.removeRoundedBg();
        const w = useInitialPosition ? this.initialPosition.w : this.width;
        const h = useInitialPosition ? this.initialPosition.h : this.height;
        this.roundedBg = new RoundedBgView(w, h, this, texture, radius);
    }
    sameRoundedBg(texture) {
        if (this.roundedBg == undefined) return false;
        return this.roundedBg.isSameBg(texture);
    }
    removeRoundedBg() {
        if (this.roundedBg == undefined) return;
        if (this.roundedBg.parent == undefined) return;
        this.roundedBg.parent.removeChild(this.roundedBg);
    }
    removeBg() {
        if (this.bg.parent == undefined) return;
        this.bg.parent.removeChild(this.bg);
    }
    replaceOldBg(newBg) {
        if (this.bg != undefined && this.bg.parent != undefined) this.bg.parent.removeChild(this.bg);
        this.bg = newBg;
    }
    makeRoundedBgInvisible() {
        this.drawRoundedBg();
        this.roundedBg.alpha = 0;
    }
    constructor(x, y, w, h, container, removePadding = false){
        super(x, y, w, h, container, removePadding);
        this.initialPosition = {
            x: this.x,
            y: this.y,
            w: this.width,
            h: this.height
        };
    }
}
